import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage1.png'
import _imports_1 from '@/assets/images/icon_delete_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d4efe002")

_pushScopeId("data-v-d4efe002")
const _hoisted_1 = { class: "common-recipe-list-item" }
const _hoisted_2 = { class: "common-recipe-list-item-info-image" }
const _hoisted_3 = {
  key: 1,
  class: "common-recipe-list-item-info-no-image",
  src: _imports_0
}
const _hoisted_4 = { class: "common-recipe-list-item-info-right-area" }
const _hoisted_5 = { class: "commonTextBodyStrong common-recipe-list-item-info-text" }
const _hoisted_6 = { class: "common-recipe-list-item-info-appliance-category-area" }
const _hoisted_7 = { class: "common-recipe-list-item-info-appliance-category-label" }
const _hoisted_8 = { class: "common-recipe-list-item-info-foodids-area" }
const _hoisted_9 = { class: "common-recipe-list-item-button-area-button-container" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "common-recipe-list-item-button-area-button-container-button-delete-image",
  src: _imports_1
}, null, -1)
const _hoisted_11 = { class: "common-recipe-list-item-button-area-button-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeFoodIds = _resolveComponent("CommonRecipeFoodIds")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "common-recipe-list-item-info",
      style: _ctx.styleRecipeInfoWidth,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectAction(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.recipeImageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "common-recipe-list-item-info-image-icon",
              src: _ctx.recipeImageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
            }, null, 40, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.recipeTitle), 1),
        _createVNode("div", _hoisted_6, [
          (_ctx.getCategoryIcon(_ctx.recipeApplianceCategoryId))
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "common-recipe-list-item-info-appliance-category-icon",
                src: _ctx.getCategoryIcon(_ctx.recipeApplianceCategoryId)
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.recipeApplianceCategory), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CommonRecipeFoodIds, { foodIds: _ctx.recipeFoodIds }, null, 8, ["foodIds"])
        ])
      ])
    ], 4),
    _createVNode("div", {
      class: "common-recipe-list-item-button-area",
      style: _ctx.styleDeleteButton
    }, [
      _createVNode("div", _hoisted_9, [
        _createVNode("button", {
          class: "common-recipe-list-item-button-area-button-container-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteAction(...args)))
        }, [
          _hoisted_10
        ])
      ])
    ], 4),
    _createVNode("div", {
      class: "common-recipe-list-item-button-area",
      style: _ctx.styleCheckButton
    }, [
      _createVNode("div", _hoisted_11, [
        _createVNode("button", {
          class: "common-recipe-list-item-button-area-button-container-button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkAction(...args)))
        }, [
          _createVNode("img", {
            class: "common-recipe-list-item-button-area-button-container-button-check-image",
            src: _ctx.checkedImage
          }, null, 8, ["src"])
        ])
      ])
    ], 4)
  ]))
})